export enum ModelType {
    AveragedPerceptron = "AveragedPerceptron",
    SdcaNonCalibrated = "SdcaNonCalibrated",
    SgdNonCalibrated = "SgdNonCalibrated",
    LinearSvm = "LinearSvm",
    LbfgsLogisticRegression = "LbfgsLogisticRegression",
    KMeans = "KMeans",
    NaiveBayes = "NaiveBayes",
    SdcaRegression = "SdcaRegression",
    SdcaMaximumEntropy = "SdcaMaximumEntropy",
    LbfgsPoissonRegression = "LbfgsPoissonRegression",
    OnlineGradientDescent = "OnlineGradientDescent",
    LbfgsMaximumEntropy = "LbfgsMaximumEntropy",
    OneVersusAll = "OneVersusAll",
    PairwiseCoupling = "PairwiseCoupling",
    NeuralNetwork = "NeuralNetwork",
    Onnx = "Onnx",
    RandomForest = "RandomForest",
    LightGbm = "LightGbm",
    RandomForestRegression = "RandomForestRegression",
    LightGbmRegression = "LightGbmRegression"
}

export const ModelTypeDisplayNames: Record<ModelType, string> = {
    [ModelType.AveragedPerceptron]: "Averaged Perceptron",
    [ModelType.SdcaNonCalibrated]: "SDCA",
    [ModelType.SgdNonCalibrated]: "SGD",
    [ModelType.LinearSvm]: "Linear SVM",
    [ModelType.LbfgsLogisticRegression]: "LBFGS Logistic Regression",
    [ModelType.KMeans]: "K-Means",
    [ModelType.NaiveBayes]: "Naive Bayes",
    [ModelType.SdcaRegression]: "SDCA Regression",
    [ModelType.SdcaMaximumEntropy]: "SDCA Maximum Entropy",
    [ModelType.LbfgsPoissonRegression]: "LBFGS Poisson Regression",
    [ModelType.OnlineGradientDescent]: "Online Gradient Descent",
    [ModelType.LbfgsMaximumEntropy]: "LBFGS Maximum Entropy",
    [ModelType.OneVersusAll]: "One Versus All",
    [ModelType.PairwiseCoupling]: "Pairwise Coupling",
    [ModelType.NeuralNetwork]: "Neural Network",
    [ModelType.Onnx]: "ONNX",
    [ModelType.RandomForest]: "Random Forest",
    [ModelType.LightGbm]: "LightGBM",
    [ModelType.RandomForestRegression]: "Random Forest Regression",
    [ModelType.LightGbmRegression]: "LightGBM Regression"
};
